import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["option", "children", "disallowedUserTooltip", "DisallowedTeamFormattedMessage"];
import styled from 'styled-components';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { extractTeamIdFromSelect } from './UsersAndTeamsSearchUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const IndentedTeamOption = styled.div.withConfig({
  displayName: "UsersAndTeamsSearchOptionComponent__IndentedTeamOption",
  componentId: "gk4iqe-0"
})(["padding-left:", ";"], props => `${props.depth * 10}px`);
const UsersAndTeamsSearchOptionComponent = _ref => {
  let {
      option,
      children,
      disallowedUserTooltip,
      DisallowedTeamFormattedMessage
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (option.depth) {
    if (option.disabled) {
      return /*#__PURE__*/_jsx(UITooltip, {
        placement: "left",
        title: /*#__PURE__*/_jsx(DisallowedTeamFormattedMessage, {
          teamId: extractTeamIdFromSelect(option.value),
          teamName: option.text
        }),
        children: /*#__PURE__*/_jsx(IndentedTeamOption, Object.assign({
          depth: option.depth
        }, rest, {
          children: children
        }))
      });
    }
    return /*#__PURE__*/_jsx(IndentedTeamOption, Object.assign({
      depth: option.depth
    }, rest, {
      children: children
    }));
  }
  if (option.isMemberOfSelectedTeam) {
    return /*#__PURE__*/_jsx(UITooltip, {
      placement: "left",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ui-asset-management-lib.tooltips.userTooltip"
      }),
      children: /*#__PURE__*/_jsx("div", Object.assign({}, rest, {
        children: children
      }))
    });
  }
  if (option.isUserDisabled && disallowedUserTooltip) {
    return /*#__PURE__*/_jsx(UITooltip, {
      placement: "left",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: disallowedUserTooltip
      }),
      children: /*#__PURE__*/_jsx("div", Object.assign({}, rest, {
        children: children
      }))
    });
  }
  if (option.disabled) {
    return /*#__PURE__*/_jsx(UITooltip, {
      placement: "left",
      title: /*#__PURE__*/_jsx(DisallowedTeamFormattedMessage, {
        teamId: extractTeamIdFromSelect(option.value),
        teamName: option.text
      }),
      children: /*#__PURE__*/_jsx("div", Object.assign({}, rest, {
        children: children
      }))
    });
  }
  return /*#__PURE__*/_jsx("div", Object.assign({}, rest, {
    children: children
  }));
};
export default UsersAndTeamsSearchOptionComponent;